import {
  EamAssetPermissionSet,
  EamContactPermissionSet,
  EamEnergyEntryPermissionSet,
  EamInspectionFormPermissionSet,
  EamInspectionPermissionSet,
  EamInventoryPermissionSet,
  EamIssuePermissionSet,
  EamLocationPermissionSet,
  EamMeterEntryPermissionSet,
  EamPartPermissionSet,
  EamPurchaseOrderPermissionSet,
  EamServiceEntryPermissionSet,
  EamServiceProgramPermissionSet,
  EamServiceReminderPermissionSet,
  EamServiceSchedulePermissionSet,
  EamServiceScheduleTaskPermissionSet,
  EamServiceTaskPermissionSet,
  EamSettingPermissionSet,
  EamVendorPermissionSet,
  EamWorkOrderPermissionSet,
  OperationalAlertsPermissionSet,
  PermissionSetType,
  SidebarProductVisibilityPermissionSet,
} from '../sets'
import { AdminMinimalRole } from './AdminMinimalRole'

/**
 * EAM Viewer Role has only READ/GET permission access of EAM
 */
export const EamViewerRole: PermissionSetType[] = [
  ...AdminMinimalRole,
  SidebarProductVisibilityPermissionSet.ShowEamProduct,
  OperationalAlertsPermissionSet.Subscribe,
  EamAssetPermissionSet.View,
  EamContactPermissionSet.View,
  EamInventoryPermissionSet.View,
  EamIssuePermissionSet.View,
  EamLocationPermissionSet.View,
  EamPartPermissionSet.View,
  EamVendorPermissionSet.View,
  EamInspectionPermissionSet.View,
  EamServiceEntryPermissionSet.View,
  EamServiceProgramPermissionSet.View,
  EamServiceSchedulePermissionSet.View,
  EamServiceScheduleTaskPermissionSet.View,
  EamServiceTaskPermissionSet.View,
  EamInspectionFormPermissionSet.View,
  EamWorkOrderPermissionSet.View,
  EamServiceReminderPermissionSet.View,
  EamPurchaseOrderPermissionSet.View,
  EamMeterEntryPermissionSet.View,
  EamSettingPermissionSet.View,
  EamEnergyEntryPermissionSet.View,
]
